import React, {Component} from 'react'

import Content from '../Content'
import Item from '../Item'
import Link from '../Link'
import List from '../Lists'

class Happenings extends Component {

  render () {

    const {
      entry
    } = this.props

    let type = entry.locationCategory

    console.log('entry location', entry);



    if ( type == "stay") {

      return (
        <div className="Template-section Template-section--narrow  Template-section--happenings">

          <div className="Template-heading">
              <Content modifier={'alt'}>
                <h1>Happenings</h1>
              </Content>
          </div>

          <div className="Template-content">

            <div className="Happenings">

                <div className="Happenings-container">

                   <List modifiers={['locations','happenings']}>
                    <li className="List-item  List-item--heading">
                      <Content>

                        <h3>mon 10.16</h3>

                      </Content>
                    </li>

                    <li className="List-item  List-item--content">
                      <Item modifiers={['article']}>
                        <a href="#">

                          <div className="Item-head">

                            <div className="Item-title">

                              <Content modifier={'yellow'}>

                                <h4>12th annual record store day vinyl party</h4>

                              </Content>

                              <Content>

                                <h4>Music</h4>

                              </Content>

                            </div>

                            <div className="Item-date">

                              <Content>

                                <h4>12.00AM</h4>

                              </Content>

                            </div>
                          </div>

                        </a>
                      </Item>

                    </li>
                  </List>

                </div>

                <div className="Happenings-container  Happenings-container--odd">

                  <List modifiers={['locations','happenings']}>

                    <li className="List-item  List-item--heading">
                <Content>

                  <h3>fri 10.20</h3>

                </Content>
              </li>

              <li className="List-item  List-item--content">

                <Item modifiers={['article']}>

                  <a href="#">

                    <div className="Item-head">

                      <div className="Item-title">

                        <Content modifier={'yellow'}>

                          <h4>by the power of greyscale: black and white music photography</h4>

                        </Content>

                        <Content>

                          <h4>arts</h4>

                        </Content>

                      </div>

                      <div className="Item-date">

                        <Content>

                          <h4>10.00am - 8.00pm</h4>

                        </Content>

                      </div>
                    </div>

                  </a>

                </Item>

              </li>

                  </List>

                </div>

                <div className="Happenings-container">

                   <List modifiers={['locations','happenings']}>

                    <li className="List-item  List-item--heading">
                <Content>

                  <h3>fri 10.20</h3>

                </Content>
              </li>

              <li className="List-item  List-item--content">

                <Item modifiers={['article']}>

                  <a href="#">

                    <div className="Item-head">

                      <div className="Item-title">

                        <Content modifier={'yellow'}>

                          <h4>by the power of greyscale: black and white music photography</h4>

                        </Content>

                        <Content>

                          <h4>arts</h4>

                        </Content>

                      </div>

                      <div className="Item-date">

                        <Content>

                          <h4>10.00am - 8.00pm</h4>

                        </Content>

                      </div>
                    </div>

                  </a>

                </Item>

              </li>

                  </List>

                </div>

                <div className="Happenings-container  Happenings-container--odd">

                   <List modifiers={['locations','happenings']}>

                    <li className="List-item  List-item--heading">
                <Content>

                  <h3>fri 10.20</h3>

                </Content>
              </li>

              <li className="List-item  List-item--content">

                <Item modifiers={['article']}>

                  <a href="#">

                    <div className="Item-head">

                      <div className="Item-title">

                        <Content modifier={'yellow'}>

                          <h4>by the power of greyscale: black and white music photography</h4>

                        </Content>

                        <Content>

                          <h4>arts</h4>

                        </Content>

                      </div>

                      <div className="Item-date">

                        <Content>

                          <h4>10.00am - 8.00pm</h4>

                        </Content>

                      </div>
                    </div>

                  </a>

                </Item>

              </li>

                  </List>

                </div>

            </div>



          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

export default Happenings



// WEBPACK FOOTER //
// ./src/js/components/Happenings/Happenings.jsx